export default __webpack_public_path__ + "static/media/line.06d8580c.png";